
export const Defaultalerts = [
  
  { id: 1, text: 'Top', class: 'top' },
  { id: 2, text: 'Left', class: 'left' },
  { id: 3, text: 'Bottom', class: 'bottom' },
  { id: 4, text: 'Right', class: 'right' },

];

export const Colorheaderalerts = [
  { id: 1, text: 'Primary', class: 'top', color: 'outline-primary', color1: 'primary', color2: '' },
  { id: 2, text: 'Secondary', class: 'right', color: 'outline-secondary', color1: 'secondary', color2: '' },
  { id: 3, text: 'Info', class: 'bottom', color: 'outline-info', color1: 'info', color2: 'bs-popover-auto' },
  { id: 4, text: 'Warning', class: 'left', color: 'outline-warning', color1: 'warning', color2: '' },
  { id: 4, text: 'Success', class: 'top', color: 'outline-success', color1: 'success', color2: '' },
  { id: 4, text: 'Danger', class: 'top', color: 'outline-danger', color1: 'danger', color2: '' },
];

export const Colredalerts = [
  { id: 1, text: 'Primary', class: 'top', color1: 'primary' },
  { id: 2, text: 'Secondary', class: 'right', color1: 'secondary' },
  { id: 3, text: 'Info', class: 'bottom', color1: 'info' },
  { id: 4, text: 'Warning', class: 'left', color1: 'warning' },
  { id: 4, text: 'Success', class: 'top', color1: 'success' },
  { id: 4, text: 'Danger', class: 'right', color1: 'danger' },
  { id: 4, text: 'Teal', class: 'bottom', color1: 'teal' },
  { id: 4, text: 'Purple', class: 'left', color1: 'purple' },
];

export const Dismissiblealerts = [
  { id: 1, color: 'primary', class: 'top' },
  { id: 2, color: 'secondary', class: 'right' },
  { id: 3, color: 'info', class: 'bottom' },
  { id: 4, color: 'warning', class: 'left' },
];
